import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getInitialsOfUserName, getFormattedFullOrderTimeLeft } from "../../utils/global";
import { ReactComponent as StopwatchIcon } from "../../assets/icons/stopwatch.svg";
import { ReactComponent as SunIcon } from "../../assets/icons/sun.svg";
import { ReactComponent as MoonIcon } from "../../assets/icons/moon.svg";
import { ReactComponent as HomeIcon } from "../../assets/icons/home.svg";

const TopHeaderBar = ({user_image, shop_name, meta_data, order_created_at, order_type}) => {
  const navigate = useNavigate();
  const location = useLocation();

  //app theme (light/dark) start
  const [theme, setTheme] = useState(() => {
    // Load saved theme from localStorage if exists, otherwise default to "dark"
    return localStorage.getItem("sc_theme") || "light";
  });
  
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("sc_theme", theme); // Save theme whenever it changes
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === "light" ? "dark" : "light"));
  };
  //app theme (light/dark) end

  const goBackToHomeButton = () => {
    navigate("/");
  };

  const validImage = user_image !== '' && user_image !== null && user_image !== undefined;

  const [formatted_timeout, set_formatted_timeout] = useState(getFormattedFullOrderTimeLeft(order_created_at, meta_data?.timeout));

  useEffect(() => {
    const interval = setInterval(() => {
      const newTime = getFormattedFullOrderTimeLeft(order_created_at, meta_data?.timeout);
      
      set_formatted_timeout(newTime);
    }, 1000);

    return () => clearInterval(interval);
  }, [order_created_at, meta_data?.timeout]);

  return (
    <>
      {shop_name !== '' && shop_name !== null && shop_name !== 'None' &&
        <div className={`top-header-bar-container shopname___${shop_name}`}>
          {location.pathname !== '/' &&
            <button className={`goBackToHomeButton order_type___${order_type}`} onClick={goBackToHomeButton} title="Home">
              <HomeIcon />
            </button>
          }

          <div className="text-center">
            {validImage &&
              <>
                {shop_name === 'SuperCheckout' &&
                  <>
                    {theme === 'light' &&
                      <img src="/supercheckout-full-dark.svg" className="logoImage" alt={shop_name} title={shop_name} />
                    }
                    {theme === 'dark' &&
                      <img src="/supercheckout-full-light.svg" className="logoImage" alt={shop_name} title={shop_name} />
                    }
                  </>
                }
                {shop_name !== 'SuperCheckout' &&
                  <>
                    {/* <img src={user_image} className="logoImage" alt={shop_name} title={shop_name} /> */}
                  </>
                }
              </>
            }
            {/* {!validImage &&
              <div className="merchantNameInitialsContainer">
                <div className="merchantNameInitials" title={shop_name}>
                  {getInitialsOfUserName(shop_name)}
                </div>
              </div>
            } */}
          </div>

          {location.pathname !== '/' && typeof meta_data !== 'undefined' && meta_data !== '' && typeof order_created_at !== 'undefined' && order_created_at !== '' && typeof formatted_timeout !== 'undefined' && formatted_timeout !== '00:00' &&
            <div id="orderTimeoutContainer" className="orderTimeoutContainer" title="Time to complete full transaction">
              <StopwatchIcon/> {formatted_timeout}
            </div>
          }

          <button id="themeToggeleButton" className="themeToggeleButton" onClick={toggleTheme} title="Toggle dark mode">
            {theme === "light" ? <SunIcon /> : <MoonIcon />}
          </button>
        </div>
      }
    </>
  );
};

export default TopHeaderBar;
